<p-toast />
<div class="animated fadeIn flex justify-content-center">
  <div class="card md:col-10 col-12">
    <div class="card-body">
      <div class="container">
        <div class="col-12">
          <form class="p-fluid p-formgrid grid" [formGroup]="transactionForm">
            <div class="col-6 flex flex-column" *ngIf="transactionForm?.value?.customer">
              <div class="mb-3 text-2xl font-medium">BILL TO</div>
              <span class="mb-2">{{ transactionForm.value.customer?.name }}</span>
              <span>
                {{ transactionForm.value.customer?.address }}
              </span>
              <span>
                {{ transactionForm.value.customer?.city }}
              </span>
              <span>
                Phone:
                {{ transactionForm.value.customer?.phoneNumber }}
              </span>
              <span>
                Email Address:
                {{ transactionForm.value.customer?.email }}
              </span>
              <div class="flex">
                <p-button
                  icon="pi pi-pencil"
                  styleClass="p-button-text"
                  label="Change Customer"
                  (click)="showSearchCustomerDropdown.set(false); openSearchCustomer()"
                ></p-button>
              </div>
            </div>

            <div class="col-6" *ngIf="!transactionForm?.value?.customer">
              <div class="field-container sm:col-10">
                <div class="autocomplete-container px-2" *ngIf="showSearchCustomerDropdown()">
                  <p-autoComplete
                    appendTo="body"
                    id="customer"
                    class="sm:w-9 w-full"
                    [suggestions]="customers()"
                    (completeMethod)="getCustomerSearchResults($event)"
                    [showEmptyMessage]="true"
                    placeholder="Search/Add Customer"
                    field="name"
                    [forceSelection]="true"
                    [dropdown]="true"
                    formControlName="customer"
                    [completeOnFocus]="true"
                    [delay]="1000"
                  >
                    <ng-template pTemplate="footer">
                      <p class="p-2 bg-primary mb-0" (click)="openAddCustomerComponent()">
                        <i class="pi pi-plus mr-2"></i>
                        Add new
                      </p>
                    </ng-template>
                    <ng-template let-customer pTemplate="item">
                      {{ customer?.name }}
                      {{ customer?.email }}
                    </ng-template>
                  </p-autoComplete>
                </div>

                <div class="button-container">
                  <p-button
                    label="Add Customer"
                    severity="secondary"
                    styleClass="p-button-outlined p-button-secondary py-8 btn_add-customer text-center"
                    icon="pi pi-user-plus"
                    (onClick)="showSearchCustomerDropdown.set(true)"
                  ></p-button>
                </div>
              </div>
            </div>

            <!-- <div class="field col-12 md:col-7">
                            <label htmlFor="invoiceNumber" class="required"
                                >Invoice Number</label
                            >
                            <input
                                pInputText
                                id="invoiceNumber"
                                type="text"
                                formControlName="transactionCode"
                            />
                        </div> -->
            <div class="field col-6">
              <div class="col-12">
                <div class="grid">
                  <div class="col-4 flex align-items-center justify-content-end">
                    <label htmlFor="date" class="required">{{ utilService.toSentenceCase(transactionType) }} Number</label>
                  </div>
                  <div class="col-8">
                    <input
                      class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                      pInputText
                      type="text"
                      formControlName="transactionUniqueCode"
                      placeholder="ISA-2023-00011-INV"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col-4 flex align-items-center justify-content-end">
                    <label htmlFor="date" class="required">{{ utilService.toSentenceCase(transactionType) }} Date</label>
                  </div>
                  <div class="col-8">
                    <p-calendar
                      [showIcon]="true"
                      inputId="date"
                      formControlName="transactionDate"
                      [defaultDate]="todayDate"
                      [placeholder]="'Select ' + utilService.toSentenceCase(transactionType) + ' generation date'"
                      [touchUI]="true"
                    ></p-calendar>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="grid">
                  <div class="col-4 flex align-items-center justify-content-end">
                    <label htmlFor="due" class="required">Due Date</label>
                  </div>
                  <div class="col-8">
                    <span style="display: flex">
                      <input
                        pInputText
                        id="due"
                        type="text"
                        style="border-top-right-radius: 0; border-bottom-right-radius: 0"
                        formControlName="transactionDueDate"
                        (click)="openInvoiceDatePickerModal()"
                        placeholder="Select invoice due date"
                      />
                      <button
                        pButton
                        icon="pi pi-calendar-plus"
                        style="border-top-left-radius: 0; border-bottom-left-radius: 0; padding: 0.3rem"
                        (click)="openInvoiceDatePickerModal()"
                      ></button>
                    </span>
                  </div>
                </div>
                <!-- <p-calendar
                                    [showIcon]="true"
                                    inputId="date"
                                    formControlName="transactionDueDate"
                                    [defaultDate]="todayDate"
                                    placeholder="Select due date"
                                    [touchUI]="true"
                                ></p-calendar> -->
              </div>
            </div>
          </form>
          <div [ngClass]="transactionType === transactionTypeEnum.QUOTE ? 'mt-4' : ''">
            <p-table
              [value]="selectedItems()"
              [tableStyle]="{ 'max-height': '3rem' }"
              dataKey="id"
              responsiveLayout="stack"
              (onEditComplete)="getData($event)"
            >
              <ng-template pTemplate="caption">
                <div class="grid">
                  <div class="sm:col-12">
                    <button pButton icon="pi pi-plus" label="Add an item" (click)="linkItemDialog()" class="p-button-outlined mb-2"></button>
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th>Name</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Amount</th>
                  <th>Apply Tax</th>
                  <th></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>
                    {{ item?.name }}
                  </td>
                  <td pEditableColumn [pEditableColumnField]="item?.quantity" [pEditableColumn]="item" (onEditComplete)="getData($event)">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText [(ngModel)]="item.quantity" type="number" />
                      </ng-template>
                      <ng-template pTemplate="output">
                        <span>
                          {{ item?.quantity }}
                          <i class="pi pi-pencil ml-8"></i>
                        </span>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td pEditableColumn [pEditableColumnField]="item?.itemPrice" [pEditableColumn]="item" (onEditComplete)="getData($event)">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <input pInputText [(ngModel)]="item.itemPrice" type="number" />
                      </ng-template>
                      <ng-template pTemplate="output">
                        <span>
                          {{
                            (transactionForm.value.conversionRate ? item?.itemPrice * transactionForm.value.conversionRate : item?.itemPrice)
                              | currency
                                : (transactionForm.value.currency
                                    ? transactionForm.value.currency.symbol
                                      ? transactionForm.value.currency.symbol
                                      : transactionForm.value.currency.code
                                    : utilService.getCurrentCurrency())
                          }}
                          <i class="pi pi-pencil ml-8"></i>
                        </span>
                      </ng-template>
                    </p-cellEditor>
                  </td>
                  <td>
                    {{
                      (transactionForm.value.conversionRate
                        ? item?.itemPrice * item?.quantity * transactionForm.value.conversionRate
                        : item?.itemPrice * item?.quantity
                      )
                        | currency
                          : (transactionForm.value.currency
                              ? transactionForm.value.currency.symbol
                                ? transactionForm.value.currency.symbol
                                : transactionForm.value.currency.code
                              : utilService.getCurrentCurrency())
                    }}
                  </td>

                  <td class="pt-4">
                    <p-multiSelect [options]="taxes" [(ngModel)]="item.taxes" optionLabel="name" (onChange)="updateTaxedItems(item.taxes, item)">
                      <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                          <div>
                            {{ option.name }}({{ option.percentage }}
                            %),
                          </div>
                        </div>
                        <div *ngIf="!value || value.length === 0">Select Taxes</div>
                      </ng-template>

                      <ng-template let-tax pTemplate="item">
                        <div class="flex align-items-center gap-2">
                          <div>
                            {{ tax.name }}({{ tax.percentage }}
                            %)
                          </div>
                        </div>
                      </ng-template>

                      <ng-template pTemplate="footer">
                        <div class="add-item col-12 text-white" (click)="openAddTaxComponent()">
                          <span class="pl-2"><i class="pi pi-plus"></i> Add new tax </span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </td>

                  <td style="text-align: center">
                    <div class="flex justify-content-center align-items-center gap-3">
                      <p-button
                        icon="pi pi-calculator"
                        severity="contrast"
                        size="small"
                        outlined
                        rounded
                        pTooltip="Calculate tax applied on line item"
                        tooltipPosition="bottom"
                        (click)="openTaxCalculatorDialog(item)"
                      />
                      <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        size="small"
                        outlined
                        rounded
                        pTooltip="Remove line item"
                        tooltipPosition="top"
                        (click)="openConfirmDeleteDialog(item)"
                      />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <textarea pInputTextarea [(ngModel)]="item.description" rows="2" placeholder="Item Description"></textarea>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="mt-4 grid flex justify-content-end">
            <div class="card col-12 md:col-8">
              <div class="m-4">
                <!-- Subtotal -->
                <div class="flex justify-content-between">
                  <p>Subtotal</p>
                  <span>{{
                    (transactionForm.value.conversionRate ? subtotalTax() * transactionForm.value.conversionRate : subtotalTax())
                      | currency
                        : (transactionForm.value.currency
                            ? transactionForm.value.currency.symbol
                              ? transactionForm.value.currency.symbol
                              : transactionForm.value.currency.code
                            : utilService.getCurrentCurrency())
                  }}</span>
                </div>

                <!-- Taxes -->
                <div class="flex justify-content-between">
                  <p>Taxes</p>
                  <span>{{
                    (transactionForm.value.conversionRate ? totalTax() * transactionForm.value.conversionRate : totalTax())
                      | currency
                        : (transactionForm.value.currency
                            ? transactionForm.value.currency.symbol
                              ? transactionForm.value.currency.symbol
                              : transactionForm.value.currency.code
                            : utilService.getCurrentCurrency())
                  }}</span>
                </div>

                <!-- Discount Section -->
                <div *ngIf="showDiscount && transactionForm.get('discount')" class="flex align-items-center justify-content-between mt-3 gap-4">
                  <form [formGroup]="transactionForm" class="flex align-items-center gap-2 w-full">
                    <div formGroupName="discount" class="flex gap-2 align-items-center">
                      <p class="mb-0">Discount</p>

                      <input
                        type="text"
                        pInputText
                        formControlName="description"
                        placeholder="Discount description (optional)"
                        class="flex-grow p-inputtext-sm"
                      />

                      <input
                        *ngIf="transactionForm.get('discountType')?.value === 'amount'"
                        type="number"
                        pInputText
                        formControlName="amount"
                        class="w-4 p-inputtext-sm"
                      />

                      <input
                        *ngIf="transactionForm.get('discountType')?.value === 'percentage'"
                        type="number"
                        pInputText
                        formControlName="percentage"
                        class="w-4 p-inputtext-sm"
                      />
                    </div>

                    <!-- Discount Type Dropdown -->
                    <p-dropdown formControlName="discountType" [options]="discountTypes" class="p-inputtext-sm"></p-dropdown>
                  </form>

                  <span class="font-bold">{{
                    discountValue$
                      | async
                      | currency
                        : (transactionForm.value.currency
                            ? transactionForm.value.currency.symbol
                              ? transactionForm.value.currency.symbol
                              : transactionForm.value.currency.code
                            : utilService.getCurrentCurrency())
                  }}</span>
                  <i class="pi pi-trash cursor-pointer text-red-500" (click)="removeDiscount()"></i>
                </div>

                <!-- Add Discount Button -->
                <button
                  *ngIf="!showDiscount"
                  pButton
                  label="Add Discount"
                  icon="pi pi-plus"
                  class="p-button-text p-button-sm mt-2"
                  (click)="showDiscount = true"
                ></button>
                <!-- Total Section -->
                @if (formattedCurrencyList().length > 0) {
                  <div class="flex justify-content-between align-items-center mt-3">
                    <div class="text-lg font-semibold">Total</div>
                    <div class="flex align-items-center gap-2 w-auto">
                      <form [formGroup]="transactionForm">
                        <p-dropdown
                          formControlName="currency"
                          [options]="formattedCurrencyList()"
                          optionLabel="formattedLabel"
                          optionValue="currencySymbolOrCode"
                          [filter]="true"
                          filterBy="formattedLabel"
                          [showClear]="true"
                          class="p-inputtext-sm"
                        ></p-dropdown>
                      </form>
                      <span class="font-bold text-lg">
                        {{
                          (transactionForm.value.conversionRate
                            ? (subtotalTax() + totalTax()) * transactionForm.value.conversionRate - getDiscountValue()
                            : subtotalTax() + totalTax() - getDiscountValue()
                          )
                            | currency
                              : (transactionForm.value.currency
                                  ? transactionForm.value.currency.symbol
                                    ? transactionForm.value.currency.symbol
                                    : transactionForm.value.currency.code
                                  : utilService.getCurrentCurrency())
                        }}
                      </span>
                    </div>
                  </div>
                }

                <!-- Expected return section -->

                <div class="flex justify-content-between align-items-center mt-3">
                  <div class="flex align-items-center">
                    <span class="text-lg font-semibold"> Expected Return </span>
                  </div>
                  <div class="flex align-items-center gap-2">
                    <span class="font-bold text-lg">
                      {{
                        (transactionForm.value.conversionRate ? expectedReturn() * transactionForm.value.conversionRate : expectedReturn())
                          | currency
                            : (transactionForm.value.currency
                                ? transactionForm.value.currency.symbol
                                  ? transactionForm.value.currency.symbol
                                  : transactionForm.value.currency.code
                                : utilService.getCurrentCurrency())
                      }}
                      <span class="ml-2 text-sm"> ({{ expectedReturnPercentage() | number: '1.1-1' }}% margin) </span>
                    </span>
                  </div>
                </div>

                @if (transactionForm.value.conversionRate !== 1 && subtotalTax() > 0) {
                  <div class="text-right mt-4">
                    <p class="font-semibold">
                      Currency conversion:
                      <span class="text-color-secondary">{{
                        subtotalTax() + totalTax() - getDiscountValue() | currency: utilService.getCurrentCurrency()
                      }}</span>
                      at
                      <ng-container *ngIf="!isEditingConversionRate; else conversionRateEditor">
                        <span (click)="startEditingConversionRate()" class="cursor-pointer text-color-secondary">
                          {{ transactionForm.value.conversionRate }}
                        </span>
                      </ng-container>
                      <ng-template #conversionRateEditor>
                        <span class="flex flex-row gap-2">
                          <input
                            pInputText
                            type="number"
                            class="p-inputtext-sm w-20"
                            [(ngModel)]="tempConversionRate"
                            (keydown.enter)="saveConversionRate()"
                            (keydown.escape)="cancelEditingConversionRate()"
                            #conversionRateInput
                          />
                          <button pButton icon="pi pi-check" class="p-button-sm p-button-text" (click)="saveConversionRate()"></button>
                          <button pButton icon="pi pi-times" class="p-button-sm p-button-text" (click)="cancelEditingConversionRate()"></button>
                        </span>
                      </ng-template>
                    </p>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12 flex align-items-end border-top-1 surface-border">
            <div [formGroup]="transactionForm" class="w-12">
              <label htmlFor="notes" class="text-lg font-semibold">Customer Notes/Terms</label>
              <textarea
                rows="6"
                cols="35"
                pInputTextarea
                placeholder="Enter notes or terms of service that are visible to your customer."
                id="notes"
                formControlName="customerNotes"
                class="mt-4"
              ></textarea>
              <!-- <small id="help" class="block"
                                >Will be displayed on the
                                {{
                                    utilService.toSentenceCase(transactionType)
                                }}.</small
                            > -->
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="border-top-1 border-bottom-1 surface-border">
            <div class="col-12">
              <label htmlFor="notes" class="text-lg font-semibold">Footer</label>
              <div *ngIf="!editTransactionTagLine" (click)="editTransactionTagLine = true" style="cursor: pointer" class="text-center">
                {{ transactionTagLine }}
                <i class="pi-pencil pi"></i>
              </div>
              <div *ngIf="editTransactionTagLine">
                <div class="grid w-6 mx-auto">
                  <div class="col p-0">
                    <div class="flex flex-column gap-2">
                      <input pInputText id="username" aria-describedby="username-help" [(ngModel)]="transactionTagLine" />
                      <small id="username-help">This will appear in all transactions</small>
                    </div>
                  </div>
                  <div class="col-auto">
                    <p-button icon="pi pi-save" (onClick)="updateTransactionTagLine()"></p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-end mr-4 my-2">
          <button
            pButton
            icon="pi pi-plus"
            label="Save and continue"
            (click)="isEdit ? updateTransaction() : generateTransactionFunc()"
            class="mb-2"
            [disabled]="transactionForm.invalid"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
